import { Link } from "react-router-dom";
import { Plus, Package } from "lucide-react";
import { toast } from "sonner";
import { useQuote } from "@/context/QuoteContext";
import { STOCK_LABEL, STOCK_STYLE, fmtPrice } from "@/lib/api";

export const ProductCard = ({ p }) => {
  const { add, setOpen } = useQuote();
  const onAdd = (e) => {
    e.preventDefault();
    add(p);
    toast.success(`${p.name} added to quote list`, { action: { label: "View", onClick: () => setOpen(true) } });
  };
  return (
    <Link to={`/products/${p.product_id}`} data-testid={`product-card-${p.product_id}`}
      className="group sr-card sr-lift overflow-hidden flex flex-col">
      <div className="aspect-[4/3] overflow-hidden bg-slate-50 relative">
        <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wider text-white px-2.5 py-1 rounded-full" style={{ background: p.brand_accent || "#0B1F4B" }}>
          {p.brand_name}
        </span>
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div>
          <p className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">{p.category} · {p.size}</p>
          <h3 className="mt-1 text-lg font-bold text-[#0B1F4B] leading-tight">{p.name}</h3>
          {p.flavor_profile && <p className="text-sm text-slate-500 mt-0.5">{p.flavor_profile}</p>}
        </div>
        <div className="flex flex-wrap gap-2 text-[11px] font-semibold">
          {p.case_pack && <span className="inline-flex items-center gap-1 rounded-full bg-[#EBF3FE] text-[#1E40AF] px-2.5 py-1 font-mono"><Package size={12} /> Case {p.case_pack}</span>}
          <span className={`rounded-full px-2.5 py-1 ${STOCK_STYLE[p.stock_status]}`} data-testid={`stock-badge-${p.product_id}`}>{STOCK_LABEL[p.stock_status]}</span>
        </div>
        <div className="mt-auto flex items-center justify-between pt-2 border-t border-slate-100">
          <span className="text-sm font-bold text-[#0B1F4B]" data-testid={`price-badge-${p.product_id}`}>
            {p.price_on_request ? <span className="text-[#1E7CF2] uppercase text-xs tracking-wider">Price on request</span> : fmtPrice(p.display_price)}
          </span>
          <button onClick={onAdd} data-testid={`request-quote-button-${p.product_id}`}
            className="inline-flex items-center gap-1 rounded-full bg-[#0B1F4B] text-white text-xs font-semibold px-3 py-2 hover:bg-[#1E7CF2] transition-colors">
            <Plus size={14} /> Quote
          </button>
        </div>
      </div>
    </Link>
  );
};
